/* eslint-disable @typescript-eslint/no-non-null-assertion */
import * as React from "react";
import { Breadcrumbs as MuiBreadcrumbs, Link, Typography } from "@mui/material";
import { useNavigation } from "../../hooks/useNavigation";

interface Props {
  breadcrumbs: BreadcrumbItem[];
}

export interface BreadcrumbItem {
  label: string;
  path?: string;
  active?: boolean;
}

const Breadcrumbs: React.FC<Props> = ({ breadcrumbs }) => {
  const { navigateTo } = useNavigation();
  const onBreadcrumbItemClick = React.useCallback(
    (path: string) => {
      navigateTo(path);
    },
    [navigateTo]
  );

  return (
    <MuiBreadcrumbs>
      {breadcrumbs.map(breadcrumbItem => (
        <span key={breadcrumbItem.label}>
          {breadcrumbItem.active ? (
            <Typography color="text.primary">{breadcrumbItem.label}</Typography>
          ) : (
            <Link
              underline="hover"
              component="button"
              color="inherit"
              onClick={breadcrumbItem.path ? () => onBreadcrumbItemClick(breadcrumbItem.path!) : undefined}
            >
              {breadcrumbItem.label}
            </Link>
          )}
        </span>
      ))}
    </MuiBreadcrumbs>
  );
};

export { Breadcrumbs };
